import { createSlice } from "@reduxjs/toolkit";
import { loadClientSettings } from "../thunks/clientSettingsThunks";
import type { ClientSettingsActionTypes, ClientSettingsState } from "../types/clientSettingsState.types";
import { CLIENT_SETTINGS_SLICE_NAME } from "../utils/storeUtils";

const initialState: ClientSettingsState = {
  loaded: false,
  loadingFailed: false,
};

const clientSettingsSlice = createSlice({
  name: CLIENT_SETTINGS_SLICE_NAME,
  initialState,
  reducers: {
    setSettings: (state, action: ClientSettingsActionTypes["setSettings"]) => {
      state.settings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadClientSettings.fulfilled, (state) => {
      state.loaded = true;
      state.loadingFailed = false;
    });
    builder.addCase(loadClientSettings.rejected, (state) => {
      state.loadingFailed = true;
      state.loaded = false;
    });
  },
});

export default clientSettingsSlice.reducer;
